import { render, staticRenderFns } from "./MarketingConsoleForm.vue?vue&type=template&id=56a161a2&scoped=true&"
import script from "./MarketingConsoleForm.vue?vue&type=script&lang=js&"
export * from "./MarketingConsoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a161a2",
  null
  
)

export default component.exports